import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { BREAK_TIME_AFTER_EACH_ITERATION } from '../../../templates/compete';
import "./canvascompetestartoverlay.style.scss";

export const CANVAS_COMPETE_START_OVERLAY_CLASS = 'canvas-compete-start-overlay';

type Props = {
  canStartDrawing: boolean;
  canvasHeight: number;
};

const CanvasCompeteStartOverlay: React.FC<Props> = ({ canStartDrawing, canvasHeight }) => {
  const [countDown, setCountDown] = useState(BREAK_TIME_AFTER_EACH_ITERATION);
  const [competeTextHideClass, setCompeteTextHideClass] = useState('');
  const [moveStartTextClass, setMoveStartTextClass] = useState('');
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (countDown > 0) {
      interval = setInterval(() => {
        setCountDown(prevCountDown => prevCountDown - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [countDown]);

  useEffect(() => {
    if (canStartDrawing) {
      setCompeteTextHideClass(`${CANVAS_COMPETE_START_OVERLAY_CLASS}-item--hide`);
      setMoveStartTextClass(`${CANVAS_COMPETE_START_OVERLAY_CLASS}-item--enlarge`);
    }
  }, [canStartDrawing]);

  return (
    <div
      className={CANVAS_COMPETE_START_OVERLAY_CLASS}
      style={{
        top: `${canvasHeight / 2 - 40}px`,
      }}
    >
      <div className={CANVAS_COMPETE_START_OVERLAY_CLASS + '__first-line'}>
        <span
          className={
            CANVAS_COMPETE_START_OVERLAY_CLASS + '__first-line-start ' +
            moveStartTextClass
          }
        >
          Start drawing
        </span>
        <span
          className=
          {CANVAS_COMPETE_START_OVERLAY_CLASS + '__first-line-text ' +
            competeTextHideClass
          }
        >
          {' '}
          the model
        </span>
      </div>
      <div className={CANVAS_COMPETE_START_OVERLAY_CLASS + '__second-line'}>
        <span
          className={CANVAS_COMPETE_START_OVERLAY_CLASS + '__second-line-text ' +
            competeTextHideClass
          }
        >
          here in{' '}
        </span>
        <span
          className={CANVAS_COMPETE_START_OVERLAY_CLASS + '__second-line-text-counter ' +
            competeTextHideClass
          }
        >
          {countDown}
        </span>
        <span
          className={CANVAS_COMPETE_START_OVERLAY_CLASS + '__second-line-text ' +
            competeTextHideClass
          }
        >
          {' '}
          seconds
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    canvasHeight,
  } = state;
  return {
    canvasHeight,
  };
};

export default connect(mapStateToProps, {})(CanvasCompeteStartOverlay);
